export const getBaseUrl = () => {
  return '/';
};
